<app-block-ui></app-block-ui>
<loading-bar></loading-bar>
<sick-header></sick-header>
<app-toast-controller></app-toast-controller>
<sick-footer></sick-footer>
